/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import Vue from 'vue';

//support vuex
import Vuex from 'vuex'
import cart from './store/cart'
import numberDecimals from './store/numberDecimals'
Vue.use(Vuex)
const store = new Vuex.Store(
    {
        modules: {
            cart,
            numberDecimals
        }
    }
)
//support vuex END

import Vuetify from 'vuetify';
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#DD730F',
                secondary: '#fd5523',
                accent: '#fffbe6',
                current: '#28AC00',
            },
            dark: {
                primary: '#37966f',
                secondary: '#b9e4c9',
                accent: '#fffbe6',
            },
        },
    },
})

// Notification
import VueNotification from '@mathieustan/vue-notification';
Vue.use(VueNotification, {
    theme: {
        colors: {
            success: '#43A047',
            darkenSuccess: '#2E7D32',
            info: '#039BE5',
            darkenInfo: '#01579B',
            warning: '#FB8C00',
            darkenWarning: '#E65100',
            error: '#E53935',
            darkenError: '#B71C1C',
            offline: '#E53935',
            darkenOffline: '#B71C1C',
        },
        boxShadow: '0px 0px 1px black',
    },
    breakpoints: {
        0: {
            bottom: true,
        },
        480: {
            bottom: true,
            left: true,
        },
    },
});

// VueSimpleAlert
import VueSimpleAlert from 'vue-simple-alert';
Vue.use(VueSimpleAlert);

// vue2Editor
import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

// graph
import { VueCharts } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
Vue.component('line-chart', {
    extends: VueCharts.Bar,
    props: ['datasets'],
    mounted () {
        this.addPlugin(ChartJSPluginDatalabels)
        this.renderChart(
            {
                labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                datasets: this.datasets
            },
            {
                responsive: true,
                legend: {
                    display: true,
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        // categoryPercentage: 0.5,
                        // barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                layout: {
                    padding: {
                        top: 30
                    }
                },
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'top',
                        formatter: (value, context) => {
                            const datasetArray = [];
                            context.chart.data.datasets.forEach(dataset => {
                                if (dataset.data[context.dataIndex] != undefined) {
                                    datasetArray.push(dataset.data[context.dataIndex])
                                }
                            });

                            function totalSum(total, datapoint) {
                                return total + datapoint;
                            }

                            let sum = datasetArray.reduce(totalSum, 0);

                            if (context.datasetIndex === datasetArray.length-1) {
                                return sum.toFixed(2);
                            } else {
                                return '';
                            }
                        }
                    }
                }
            }
        )
    }
})
Vue.component('line-chart2', {
    extends: VueCharts.Bar,
    props: ['data', 'labels'],
    mounted () {
        this.addPlugin(ChartJSPluginDatalabels)
        this.renderChart(
            {
                labels: this.labels,
                datasets: [
                    {
                        label: '',
                        backgroundColor: [
                            '#A5D6A7',
                            '#FFB74D',
                            '#81D4FA',
                            '#9575CD',
                            '#F8BBD0',
                            '#B2DFDB',
                            '#A5D6A7',
                            '#FFB74D',
                            '#81D4FA',
                            '#9575CD',
                            '#F8BBD0',
                            '#B2DFDB',
                        ],
                        data: this.data
                    }
                ]
            },
            {
				responsive: true,
				legend: {
                    display: false,
                    position: 'bottom'
                },
                scales: {
                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                maintainAspectRatio: false,
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'top',
                        formatter: (value, context) => {
                            return value.toFixed(2);
                        }
                    }
                }
  	        }
        )
    }
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('app-dashboard', require('./views/layouts/Dashboard.vue').default);
Vue.component('app-seller', require('./views/layouts/Seller.vue').default);
Vue.component('app-waiter', require('./views/layouts/Waiter.vue').default);
Vue.component('app-preventist', require('./views/layouts/Preventist.vue').default);
Vue.component('my-account', require('./views/layouts/MyAccount.vue').default);
Vue.component('app-purchase', require('./components/Purchase.vue').default);
Vue.component('seller-purchase', require('./components/PurchaseSeller.vue').default);
Vue.component('waiter-purchase', require('./components/PurchaseWaiter.vue').default);
Vue.component('google-map', require('./components/GoogleMap.vue').default);
Vue.component('orders-map', require('./components/OrdersMap.vue').default);
Vue.component('presales-map', require('./components/PresalesMap.vue').default);
Vue.component('design-settings', require('./components/designSettings.vue').default);
Vue.component('order-settings', require('./components/orderSettings.vue').default);
Vue.component('products-units', require('./components/productsUnitsGraphics.vue').default);
Vue.component('products-prices', require('./components/productsPricesGraphics.vue').default);
Vue.component('categories-units', require('./components/categoriesUnitsGraphics.vue').default);
Vue.component('categories-prices', require('./components/categoriesPricesGraphics.vue').default);
Vue.component('graphics-list', require('./components/graphicsList.vue').default);
Vue.component('graphics-list2', require('./components/graphicsList2.vue').default);
Vue.component('order-products', require('./components/OrderProducts.vue').default);
Vue.component('products-by-categories', require('./components/ProductsByCategories.vue').default);
Vue.component('my-sales', require('./components/MySales.vue').default);
Vue.component('sales-expenses', require('./components/SalesAndExpenses.vue').default);
Vue.component('add-expense', require('./components/SalesExpenses/NewExpense.vue').default);
Vue.component('add-sale', require('./components/SalesExpenses/NewSale.vue').default);
Vue.component('open-cash', require('./components/cashier/OpenCash.vue').default);
Vue.component('list-product-by-category', require('./components/SalesExpenses/listProductsByCategory.vue').default);

Vue.component('profits-results', require('./components/salesAnalysis/profitsResults').default);
Vue.component('products-results', require('./components/salesAnalysis/productsResults').default);
Vue.component('profits-graphs', require('./components/salesAnalysis/profitsGraphs').default);
Vue.component('products-graphs', require('./components/salesAnalysis/productsGraphs').default);
/**
 * admin
 */
Vue.component('list-stores', require('./views/admin/Stores.vue').default);
Vue.component('add-new-store', require('./views/admin/newStore.vue').default);
Vue.component('admin-edit-store', require('./views/admin/EditStore.vue').default);
Vue.component('list-parentstores', require('./views/admin/ParentStores.vue').default);
Vue.component('add-new-parentstore', require('./views/admin/newParentStore.vue').default);
Vue.component('edit-parentstore', require('./views/admin/editParentStore.vue').default);
/**
 * store
 */
Vue.component('main-store', require('./views/store/MainStore.vue').default);
Vue.component('setting-store', require('./views/store/Setting.vue').default);
Vue.component('banners-store', require('./views/store/Banners.vue').default);
Vue.component('socialnetworks-store', require('./views/store/SocialNetworks.vue').default);
Vue.component('setting-orders', require('./views/store/SettingOrders.vue').default);
Vue.component('categories-store', require('./views/store/Categories.vue').default);
Vue.component('complement-store', require('./views/store/Complements.vue').default);
Vue.component('list-products', require('./views/store/Products.vue').default);
Vue.component('add-new-product', require('./views/store/newProduct.vue').default);
Vue.component('edit-product', require('./views/store/editProduct.vue').default);
Vue.component('list-orders', require('./views/store/Orders.vue').default);
Vue.component('list-orders-physical', require('./views/store/OrdersPhysical.vue').default);
Vue.component('single-orderphysical', require('./views/store/OrderPhysical.vue').default);
Vue.component('single-order', require('./views/store/Order.vue').default);
Vue.component('list-clients', require('./views/store/Clients.vue').default);
Vue.component('alerts-store', require('./views/store/AlertsStore.vue').default);
Vue.component('coupons-store', require('./views/store/CouponsStore.vue').default);
Vue.component('barcode', require('./views/store/barcode.vue').default);
Vue.component('list-cashier', require('./views/store/Cashiers.vue').default);

Vue.component('expenses', require('./views/store/Expenses.vue').default);

// services
Vue.component('add-new-service', require('./views/store/newService.vue').default);
Vue.component('edit-service', require('./views/store/editService.vue').default);
Vue.component('list-reservations', require('./views/store/Reservations.vue').default);
Vue.component('single-service', require('./views/store/Reservation.vue').default);
// pages
Vue.component('add-new-page', require('./views/store/pages/newPage.vue').default);
Vue.component('list-pages', require('./views/store/pages/Pages.vue').default);
Vue.component('edit-page', require('./views/store/pages/EditPage.vue').default);
// Schedule
Vue.component('schedule-store', require('./views/store/Schedule.vue').default);
// users
Vue.component('my-users', require('./views/store/MyUsers.vue').default);
// roles
Vue.component('my-roles', require('./views/store/MyRoles.vue').default);
// invetory
Vue.component('invetory-page', require('./views/store/Inventory.vue').default);
Vue.component('inventory-suplies-page', require('./views/store/InventorySuplies.vue').default);
// retornos
Vue.component('return-investment', require('./views/store/ReturnInvestment.vue').default);
/**
 * seller
*/
Vue.component('seller-products', require('./views/seller/sellerProducts.vue').default);
Vue.component('list-sales', require('./views/seller/Sales.vue').default);
Vue.component('single-sale', require('./views/seller/Sale.vue').default);
/**
 * preventist
*/
Vue.component('preventist-products', require('./views/preventist/preventistProducts.vue').default);
Vue.component('list-presales', require('./views/preventist/PreSales.vue').default);
Vue.component('single-presale', require('./views/preventist/Presale.vue').default);
Vue.component('edit-presale', require('./views/preventist/EditPresale.vue').default);
Vue.component('products-presale', require('./components/ProductsPresale.vue').default);
/**
 * waiter
 */
Vue.component('waiter-products', require('./views/waiter/waiterProducts.vue').default);
// Vue.component('list-sales', require('./views/waiter/Sales.vue').default);
// Vue.component('single-sale', require('./views/waiter/Sale.vue').default);
/**
 * Layouts public
 */
Vue.component('app-public', require('./views/layouts/App.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
    vuetify: new Vuetify()
});
